import { UnauthorizedError } from './UnauthorizedError';
import { getCallbackUrl } from './authSession';

export const CLIENT_ID = '3fb4dbd30b5e1759c2345625fbe800a91';

export class ApiClient {
  static onUnauthorized = null;

  static token = null;

  static deviceId = null;

  static appApiUrl = null;

  static authUrl = null;

  static websiteUrl = null;

  static publicApiUrl = null;

  request = async (method, url, body, headers, secure) => {
    const defaultHeaders = {
      'Content-Type': 'application/json',
    };
    const allHeaders = { ...defaultHeaders, ...headers };

    if (secure) {
      if (!ApiClient.token) {
        if (ApiClient.onUnauthorized) ApiClient.onUnauthorized();
        return Promise.reject(new UnauthorizedError());
      }

      allHeaders.Authorization = `Bearer ${ApiClient.token}`;
    }

    const options = {
      method,
      mode: 'cors',
      headers: allHeaders,
      body: body ? JSON.stringify(body) : undefined,
    };

    return fetch(`${this.appApiUrl}${url}`, options)
      .then((resp) => {
        if (resp.status === 401) {
          if (ApiClient.onUnauthorized) {
            ApiClient.onUnauthorized();
          }

          return Promise.reject(new UnauthorizedError('Unauthorized'));
        }

        if (resp.ok || resp.status === 400) {
          return resp;
        }

        if (resp.status === 403) {
          return resp.json().then((data) => Promise.reject(data));
        }

        const errMessage = `${url} - ${resp.status}: ${resp.statusText}`;
        return Promise.reject(new Error(errMessage));
      });
  };

  get = (url, headers, secure = !!ApiClient.token) => this.request('GET', url, undefined, headers, secure)

  post = (url, body, headers, secure = !!ApiClient.token) => this.request('POST', url, body, headers, secure)

  put = (url, body, headers, secure = !!ApiClient.token) => this.request('PUT', url, body, headers, secure)

  patch = (url, body, headers, secure = !!ApiClient.token) => this.request('PATCH', url, body, headers, secure)

  fetchTokenWithCode = async (authCode) => {
    const resp = await fetch(`${this.authUrl}/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify({
        client_id: CLIENT_ID,
        code: authCode,
        redirect_uri: getCallbackUrl(),
      }),
    });
    if (!resp.ok) {
      throw new UnauthorizedError(`${this.authUrl}/token - ${resp.status}: ${resp.statusText}`);
    }
    return resp.json();
  }
}

export default new ApiClient();
